module.exports = __webpack_public_path__ + "img/leaf.e426da02.svg";